module.exports = __webpack_public_path__ + "static/media/bg-1.4b004c98.png";